import ResponsiveFileManagement from '@/components/FileManagement/ResponsiveFileManagement';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@/redux/app/actions';



const FileManage = () => {
    const dispatch = useDispatch();
    const hasCollapsedMobileMenuRef = React.useRef(false);
    const { isPC = true, collapsed = true } = useSelector((state) => state.App ?? {});
    const fileManagementProps = {
        tableName: 'All',
        recordId: null,
        equipmentId: null,
        // R1：全局 /file-manage 模式（System 目录树只读在此模式生效；默认值推导结果相同，显式标注意图）
        fileManageMode: 'global',
    };

    React.useEffect(() => {
        if (!isPC && !collapsed && !hasCollapsedMobileMenuRef.current) {
            dispatch(appActions.toggleCollapsed());
            hasCollapsedMobileMenuRef.current = true;
        }

        if (isPC) {
            hasCollapsedMobileMenuRef.current = false;
        }
    }, [collapsed, dispatch, isPC]);

    return (
        <ResponsiveFileManagement {...fileManagementProps} />
    );
};

export default React.memo(FileManage);
